import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"
}), 'ArrowBackIos');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ArrowBackIos.js
// module id = 2069
// module chunks = 2